export function getLocalTourByCode (localTours, cityLink) {
  if (!localTours || !cityLink) {
    return null
  }
  const code = cityLink.substr(4)
  if (!localTours[code] || !localTours[code].tours || !localTours[code].tours.items) {
    return null
  }
  return localTours[code].tours.items
}
